import { createRouter, createWebHistory } from "vue-router";
import baseRoutes from "./routes";

const router = createRouter({
  history: createWebHistory(),
  routes: [...baseRoutes],
});

router.beforeEach(async (to, from, next) => {
  const DEFAULT_TITLE = "Biodomi";
  document.title = (to.meta.title as string) || DEFAULT_TITLE;
  next();
});

export default router;
